module.exports = __webpack_public_path__ + "static/img/homeOneRound.fe368aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageOne/homeOneRound.png
// module id = k9R3
// module chunks = 0